// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// import i18n from './locales'
import Vue from 'vue'
import App from './App'
import router from './router'
import Element from 'element-ui'
import language from '../static/i18n/zh.js'
import 'Element-ui/lib/theme-chalk/index.css'
import './utils/axios';
import { post, get } from './utils/request';

Vue.use(Element)

let translate = localStorage.getItem('translate') ? localStorage.getItem('translate'):'zh'
Vue.config.productionTip = false
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.language = language;
Vue.prototype.LT = translate;
Vue.prototype.$EventBus = new Vue();
// 在原型对象上定义一个名为 $method 的方法
Vue.prototype.$method = function() {
  // if(translate == 'en'){
  //   localStorage.setItem('translate','zh')
  // }else{
  //   localStorage.setItem('translate','en')
  // }
  // Vue.prototype.LT = translate;
  Vue.prototype.LT = 'zh';
  this.$forceUpdate()
  location.reload()
}
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js